import {AccountActions, AccountActionType} from './account.types';
import {AccountInfo} from "../../util/interfaces";

export const successGetAccount = (accountInfo: AccountInfo): AccountActionType => ({
  type: AccountActions.SUCCESS_GET_ACCOUNT,
  payload: accountInfo
});

export const failedGetAccount = (error: string): AccountActionType => ({
  type: AccountActions.FAILED_GET_ACCOUNT,
  payload: error
});

export const successAddShopifyAttributes = (shop: string): AccountActionType => ({
  type: AccountActions.SUCCESS_ADD_SHOPIFY_ATTRIBUTES,
  payload: shop
});

export const failedAddShopifyAttributes = (error: string): AccountActionType => ({
  type: AccountActions.FAILED_ADD_SHOPIFY_ATTRIBUTES,
  payload: error
});

export const clearAccountError = (): AccountActionType => ({
  type: AccountActions.CLEAR_ACCOUNT_ERROR
})
